export default "__VITE_ASSET__D7wn9j8O__"